import { type IValidationSchema, validationContext } from 'validx'
import type { ClearInventoryItemQuantityMutator } from '@/features/legends/effects/effects'
import {
  MutatorEditorViewModelBase,
  type MutatorEditorViewModelOptions,
} from '@/features/legends/effects/MutatorEditorViewModelBase'
import type { EntityDescriptor } from '@/features/legends/editor/entities'

/**
 * Sets the quantity of service item elements to zero.
 */
export class ClearInventoryItemQuantityMutatorEditorViewModel extends MutatorEditorViewModelBase<ClearInventoryItemQuantityMutator> {
  private readonly _schema: IValidationSchema<ClearInventoryItemQuantityMutatorEditorViewModel> =
    {
      ...this.targetsSchema,
    }

  readonly type = 'ClearInventoryItemQuantity'
  readonly validation = validationContext(this, this._schema)

  constructor(options: MutatorEditorViewModelOptions) {
    super(
      options,
      'Please select the service item element(s) you wish to clear.',
    )
  }

  /** @inheritDoc */
  toJSON(): ClearInventoryItemQuantityMutator {
    return { type: this.type, targets: this.targets.toJSON() }
  }

  /** @inheritDoc */
  protected _isCompatibleTarget({ type }: EntityDescriptor) {
    return type === 'InventoryItem'
  }
}
